import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './CarbonCertificate.module.scss';

const CarbonCertificate: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.climateTradeContainer}>
      <div className={styles.contentSection}>
        <h1 className={styles.climateCertificateTitle}>{t('carbonCertification')}</h1>
        <ul className={styles.list}>
          <li className={styles.listItem}>
            <p className={styles.climateTradeText}>1. {t('carbonCertificationContent1')}</p>
          </li>
          <li className={styles.listItem}>
            <p className={styles.climateTradeText}>2. {t('carbonCertificationContent2')}</p>
          </li>
          <li className={styles.listItem}>
            <p className={styles.climateTradeText}>3. {t('carbonCertificationContent3')}</p>
          </li>
        </ul>
      </div>

      <div className={styles.imageSection}>
        <img src='/images/bg-certificate2.jpg' alt='impact' className={styles.statImage} />
      </div>
    </div>
  );
};

export default CarbonCertificate;
